import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';
import '../styles/nav.css';
import { getPatients, deletePatient } from '../services/api';
import { useServerPagination } from '../utils/serverPag';
import { normalizeRutInput } from '../utils/rutSearch';
import { formatRut } from '../utils/rut';
import { confirmar } from './ConfirmModal';
import { toast } from 'react-toastify';

const ListarPacientes = () => {
  const [searchRut, setSearchRut] = useState('');
  const [searchNombre, setSearchNombre] = useState('');
  const [searchApellidoP, setSearchApellidoP] = useState('');
  const [searchApellidoM, setSearchApellidoM] = useState('');
  const [sortField, setSortField] = useState('nombre');
  const [sortOrder, setSortOrder] = useState('asc');

  const fetchFn = useCallback(
    (opts) => getPatients({
      ...opts,
      sort: sortField,
      order: sortOrder
    }),
    [sortField, sortOrder]
  );
  const {
    items: pacientes,
    page,
    total,
    totalPages,
    loading,
    error,
    setPage,
    refresh
  } = useServerPagination(fetchFn, { initialPerPage: 20 });

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
    refresh();
  };

  const handleDelete = async (pacienteId, pacienteNombre) => {
    const confirmed = await confirmar(`¿Estás seguro de eliminar al paciente "${pacienteNombre}" ?`, { variante: 'peligro' });
    if (!confirmed) return;
    try {
      await deletePatient(pacienteId);
      toast.success(`Paciente "${pacienteNombre}" eliminado exitosamente.`);
      refresh();
    } catch (error) {
      console.error('Error al eliminar paciente:', error);
      toast.error('Error al eliminar paciente, puede tener exámenes asociados');
    }
  };

  const handleSearch = () => {
    setPage(1);
    refresh({
      rut: searchRut.trim(),
      apellido_p: searchApellidoP.trim(),
      apellido_m: searchApellidoM.trim(),
      nombre: searchNombre.trim(),
    })
  }
  
  return (
    <div>
      <div className="container-admin">
        <h1 className="section-title">Lista de Pacientes</h1>
        <div className="container">
          <form className="form-search">
            <div className="form-block">
              <label htmlFor="rut">Buscar por RUT:</label>
              <input
                type="text"
                id="rut"
                className="form-control"
                placeholder="Ej: 123456789K"
                value={searchRut}
                maxLength="9"
                onChange={(e) => setSearchRut(normalizeRutInput(e.target.value))}
              />
            </div>
            <div className="form-block">
              <label>Buscar por Nombre:</label>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nombre">Primer Nombre</label>
                  <input
                    type="text"
                    id="nombre"
                    className="form-control"
                    placeholder="Ingresa Nombre"
                    value={searchNombre}
                    onChange={(e) => setSearchNombre(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="apellido_p">Apellido Paterno</label>
                  <input
                    type="text"
                    id="apellido_p"
                    className="form-control"
                    placeholder="Ingresa Apellido Paterno"
                    value={searchApellidoP}
                    onChange={(e) => setSearchApellidoP(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="apellido_m">Apellido Materno</label>
                  <input
                    type="text"
                    id="apellido_m"
                    className="form-control"
                    placeholder="Ingresa Apellido Materno"
                    value={searchApellidoM}
                    onChange={(e) => setSearchApellidoM(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <button type="button" className="btn-create" onClick={handleSearch}>Buscar</button>
          </form>

        </div>

        {error && <div className="error">Error cargando pacientes</div>}

        <div className="container">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('nombre')}>
                    Nombre {sortField === 'nombre' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th onClick={() => handleSort('apellido_p')}>
                    Apellido Paterno {sortField === 'apellido_p' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th onClick={() => handleSort('apellido_m')}>
                    Apellido Materno {sortField === 'apellido_m' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th onClick={() => handleSort('rut')}>
                    RUT {sortField === 'rut' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={5} style={{ textAlign: 'center' }}>
                      Loading pacientes...
                    </td>
                  </tr>
                )}
                {pacientes.map((paciente) => (
                  <tr key={paciente.id_usuario}>
                    <td>{paciente.nombre}</td>
                    <td>{paciente.apellido_p}</td>
                    <td>{paciente.apellido_m}</td>
                    <td>{paciente.rut ? formatRut(paciente.rut) : ''}</td>
                    <td>
                      <div className="btn-group" style={{ flexDirection: 'column' }}>
                        <Link to={`/pacientes/editar/${paciente.id_usuario}`} className="btn-create">Editar Paciente</Link>
                        <Link to={`/evaluaciones/crear/${paciente.id_usuario}`} className="btn-secondary">Crear Evaluación</Link>
                        <button
                          type="button"
                          className="btn-danger"
                          onClick={() => handleDelete(paciente.id_usuario, paciente.nombre)}
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {pacientes.length === 0 && !loading && (
                  <tr>
                    <td colSpan={5} style={{ textAlign: 'center' }}>
                      No hay pacientes en esta página.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>

        <div className="pagination-controls">
          <button onClick={() => setPage(page - 1)} disabled={page <= 1 || loading}>Prev</button>
          <span> Página {page} de {totalPages} — {total} pacientes</span>
          <button onClick={() => setPage(page + 1)} disabled={page >= totalPages || loading}>Next</button>
        </div>
        <div className='create-button'>
          <Link to="/pacientes/crear" className="btn btn-create">Crear Paciente</Link>
        </div>

      </div>
    </div>
  );

};

export default ListarPacientes;
